import { hc } from "hono/client";
import type { OnboardingRpc } from "@typedoc/auth/rpc/onboarding";
import { validateApiBase, type RpcFetch } from "./transport";

export function createOnboardingClient(base: string, fetcher?: RpcFetch) {
  return hc<OnboardingRpc>(validateApiBase(base), {
    ...(fetcher ? { fetch: fetcher } : {}),
    init: { credentials: "include" },
    headers: { Accept: "application/json" },
  });
}

export type OnboardingClient = ReturnType<typeof createOnboardingClient>;
